module.exports = __webpack_public_path__ + "assets/img/26_728_big.5c71e598.jpg";